import { CheckboxTarget } from "@/Common/Models/UI/Inputs/CheckboxTarget";
import { CheckboxUIModel } from "@/Common/Models/UI/Inputs/CheckboxUIModel";

class GenericCheckboxUIModel<T> extends CheckboxUIModel {
    public Id: string;
    public Name: string;
    public Checked: boolean;
    public Target: CheckboxTarget;
    public Position: number;
    public Item: T;

    constructor() {
        super();
        this.Id = "";
        this.Name = "";
        this.Checked = false;
        this.Target = CheckboxTarget.Unassigned;
        this.Position = 0;
        this.Item = null;
    }
}

export { GenericCheckboxUIModel };
